export default "__VITE_ASSET__Dgvp_MVI__"